import React from 'react';
import OpportunityCard from './OpportunityCard';
import {useState, useEffect} from 'react';
import {Buffer} from 'buffer';
import { Rings } from 'react-loader-spinner'


function OpportunityTable() {

  const [opportunities, setOpportunity] = useState([]);
  const COMMAND_API_URL = process.env.REACT_APP_COMMAND_API_ENDPOINT
  const user = process.env.REACT_APP_USER
  const pass = process.env.REACT_APP_PASS
  const base64encodedData = Buffer.from(`${user}:${pass}`).toString('base64');
  
  const searchOpportunity = async(name) => {
    const response = await fetch(`${COMMAND_API_URL}/command_match/opportunities/?search=${name}`, {
      method: 'GET',
      headers: {'Content-Type': 'application/json','Authorization': 'Basic ' + base64encodedData}})
    const data = await response.json();
    setOpportunity(data);
  }
  
  useEffect(() => {
    searchOpportunity('');
  }, [])
    return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card my-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3">
                <h6 className="text-white text-capitalize ps-3">Opportunity table</h6>
              </div>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive p-0">

                  {opportunities?.length > 0 ?
                    (
                      <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opportunity</th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Description</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tags</th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">id</th>
                          <th className="text-secondary opacity-7"></th>
                        </tr>
                      </thead>
                      <tbody>
                  
                      {opportunities.map ((opportunity) => (
                        <OpportunityCard key={opportunity.id} opportunity={opportunity}/>
                      ))}
                      </tbody>
                      </table>
                    ) : (
                      <table className="table align-items-center mb-0">
                      <tbody><tr><td>
                      <Rings
                        visible={true}
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="rings-loading"
                        wrapperStyle={{}}
                        wrapperclassName=""
                        />
                      </td></tr></tbody>
                      </table>
                    )
                  }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    )
}

export default OpportunityTable;